import { EVENTS, subscribe } from "ia-util-pubsub";

// Full-page cart (templates/cart.json -> sections/ia-main-cart.liquid).
//
// Cart mutations are handled globally by window.iaCartAPI (set up by the mini
// cart drawer) and the shared <ia-cart-item> / <ia-product-qty> custom elements
// defined in ia-cart.js — those work for this page's items too. This element's
// only job is to keep the page's server-rendered markup in sync: on every cart
// change it re-fetches its own section and swaps the [data-re-render] blocks,
// mirroring how IaCart.updateBlocks keeps the drawer in sync.
class IaCartPage extends HTMLElement {
  connectedCallback() {
    this.sectionId = this.dataset.sectionId;
    this.unsubscribeBefore = subscribe(
      EVENTS.cartBeforeChange,
      this.onBeforeChange.bind(this)
    );
    this.unsubscribeChanged = subscribe(
      EVENTS.cartChanged,
      this.onChanged.bind(this)
    );
  }

  disconnectedCallback() {
    this.unsubscribeBefore?.();
    this.unsubscribeChanged?.();
  }

  onBeforeChange() {
    this.classList.add("is-loading");
  }

  async onChanged(event) {
    const count = event?.detail?.cartObj?.item_count;
    try {
      await this.refresh();
    } finally {
      // Toggle the empty/populated layout once fresh markup is in place.
      if (count !== undefined && count !== null) {
        this.dataset.itemCount = count;
      }
      this.classList.remove("is-loading");
    }
  }

  async refresh() {
    if (!this.sectionId) return;
    const url = `${window.location.pathname}?section_id=${encodeURIComponent(
      this.sectionId
    )}`;
    const response = await fetch(url);
    if (!response.ok) return;
    const html = await response.text();
    const fresh = new DOMParser().parseFromString(html, "text/html").body;

    this.querySelectorAll("[data-re-render]").forEach((block) => {
      if (!block.id) return;
      const updated = fresh.querySelector(`#${CSS.escape(block.id)}`);
      if (updated) {
        block.outerHTML = updated.outerHTML;
      }
    });
  }
}

if (!customElements.get("ia-cart-page")) {
  customElements.define("ia-cart-page", IaCartPage);
}
